import { render, staticRenderFns } from "./VPageHeader.vue?vue&type=template&id=94bad708&scoped=true&"
import script from "./VPageHeader.vue?vue&type=script&lang=js&"
export * from "./VPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./VPageHeader.vue?vue&type=style&index=0&id=94bad708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bad708",
  null
  
)

export default component.exports